import { CurrencyPipe } from "@angular/common"

function formatCurrency(amount: number, symbol: string) {
  return new CurrencyPipe('en-US').transform(amount, symbol);
}

export const COUNTRY_DETAILS = {
  suffix: {
    GB: '',
    AU: '(Inc GST)',
    NZ: ''
  }
}

export const DOCUMENT_CONSTANTS = {
  AU: {
    coi: {
      title: 'Certificate of Insurance',
      summary: 'A summary of your insurance policy, showing what’s covered and key details',
      icon: 'management-claim'
    },
    coc: {
      title: '',
      summary: 'Proof that your insurance policy is active and valid',
      icon: 'management-bankaccount'
    },
    pds: {
      title: '',
      summary: 'Explains what your insurance covers, what it doesn’t, and how it works',
      icon: 'management-aboutyourcover'
    },
    supplementary: {
      title: '',
      summary: 'Details what’s covered and what’s not, limits and conditions, and how we manage your claim',
      icon: 'management-aboutyourcover'
    }
  },
  GB: {
    coi: {
      title: 'Policy Schedule',
      summary: 'A summary of your insurance policy, showing what’s covered and key details',
      icon: 'management-aboutyourcover'
    },
    pd: {
      title: '',
      summary: 'Details what’s covered and what’s not, limits and conditions, and how we manage your claim',
      icon: 'management-aboutyourcover'
    },
    md: {
      title: '',
      summary: 'Details on the information you provided to us and any pre-existing medical conditions that we have agreed to cover',
      icon: 'management-aboutyourcover'
    },
    pds: {
      title: '',
      summary: 'Explains what your insurance covers, what it doesn’t, and how it works',
      icon: 'management-aboutyourcover'
    },
    supplementary: {
      title: '',
      summary: 'Details what’s covered and what’s not, limits and conditions, and how we manage your claim',
      icon: 'management-aboutyourcover'
    }
  }
}

export const CLAIM_CONSTANTS = {
  icons: {
    AC: 'car-comprehensive',
    HS: 'option-excessfreewindscreen',
    FT: 'marketing-fireandtheft',
    NE: 'events-lightningexplosion',
    SC: 'management-claim',
    MS: 'people-tenant',
    TP: 'marketing-visitorcontentsemergencies',
    FD: 'management-updateflightdetails',
    BD: 'marketing-visitorcontentsemergencies',
    TC: 'travel-tripcancellation',
    TU: 'travel-tripcancellation',
    ST: 'management-claim',
    C: 'car-comprehensive',
    H: 'house-home',
    T: 'travel-travel',
    M: 'marketing-marketing-optionals'
  },
  active: ['L', 'H', 'Q'],
  completed: ['V', 'W', 'F']
}

export const POLICY_ACTIONS = {
  ACTIVE_ACTIONS: [
    {
      label: 'Manage policy',
      icon: 'management-update-policy-small',
      action: 'goToSupport',
      type: 'policy'
    },
    {
      label: 'Edit payment',
      icon: 'management-payments-small',
      action: 'goToSupport',
      type: 'payment'
    },
    {
      label: 'Make a claim',
      icon: 'management-claim-small',
      action: 'goToClaim',
      type: 'claim'
    }
  ],
  ACTIVE_TRAVEL_SINGLE_ACTIONS:[
    {
      label: 'Manage policy',
      icon: 'management-update-policy-small',
      action: 'goToSupport',
      type: 'policy'
    },
    {
      label: 'Make a claim',
      icon: 'management-claim-small',
      action: 'goToClaim',
      type: 'claim'
    }
  ],
  CANCELLED_ACTIONS: [
    {
      label: 'Make a claim',
      icon: 'management-claim-small',
      action: 'goToClaim',
      type: 'claim'
    }
  ],
  INACTIVE_ACTIONS: [
    {
      label: 'Make a claim',
      icon: 'management-claim-small',
      action: 'goToClaim',
      type: 'claim'
    }
  ],
  UPCOMING_ACTIONS: [
    {
      label: 'Manage policy',
      icon: 'management-update-policy-small',
      action: 'goToSupport',
      type: 'policy'
    },
    {
      label: 'Edit payment',
      icon: 'management-payments-small',
      action: 'goToSupport',
      type: 'payment'
    }
  ]
}

export const HERO_BANNER_SNAPSHOT = {
  carSnapshot: (data: any): string => `
    <div class="flex flex-column margin-right-small" *ngIf="data.excess">
      <span class="margin-bottom-tiny text-small">Excess</span>
      <span><strong>${ formatCurrency(data.excess.amount, data.excess.currency) }</strong></span>
    </div>
  `,
  carMonthSnapshot: (data: any): string => `
    <div class="flex flex-column margin-right-small" *ngIf="data.excess">
      <span class="margin-bottom-tiny text-small">Excess</span>
      <span><strong>${ formatCurrency(data.excess.amount, data.excess.currency) }</strong></span>
    </div>
    <div class="flex flex-column margin-right-small">
      <span class="margin-bottom-tiny text-small">Next monthly payment</span>
      <span><strong>${ formatCurrency(data.firstPayableInvoice.amount, data.firstPayableInvoice.currency) } (Inc GST)</strong></span>
    </div>
  `,
  travelSnapshot: (data: any, displayDatePipe: any ): string => `
    <div class="flex flex-column margin-right-small" *ngIf="data.excess">
      <span class="margin-bottom-tiny text-small">Excess</span>
      <span><strong>${ formatCurrency(data.excess.amount, data.excess.currency) }</strong></span>
    </div>,
    <div class="flex flex-column margin-right-small">
      <span class="margin-bottom-tiny text-small">Departure date</span>
      <span><strong>${ displayDatePipe.transform(data.departureDate) }</strong></span>
    </div>
    <div class="flex flex-column margin-right-small">
      <span class="margin-bottom-tiny text-small">Return date</span>
      <span><strong>${ displayDatePipe.transform(data.returnDate) }</strong></span>
    </div>
  `,
  travelMultiSnapshot: (data: any ): string => `
    <div class="flex flex-column margin-right-small" *ngIf="data.excess">
      <span class="margin-bottom-tiny text-small">Excess</span>
      <span><strong>${ formatCurrency(data.excess.amount, data.excess.currency) }</strong></span>
    </div>
  `,
  homeSnapshot: (data: any): string => `
    <div class="flex flex-column margin-right-small" *ngIf="data.excess && data.excess.building">
      <span class="margin-bottom-tiny text-small">Home excess</span>
      <span><strong>${ formatCurrency(data.excess.building.amount, data.excess.building.currency) }</strong></span>
    </div>
    <div class="flex flex-column margin-right-small" *ngIf="data.excess && data.excess.contents">
      <span class="margin-bottom-tiny text-small">Contents excess</span>
      <span><strong>${ formatCurrency(data.excess.contents.amount, data.excess.contents.currency) }</strong></span>
    </div>
  `,
  homeMonthSnapshot: (data: any): string => `
    <div class="flex flex-column margin-right-small" *ngIf="data.excess && data.excess.building">
      <span class="margin-bottom-tiny text-small">Home excess</span>
      <span><strong>${ formatCurrency(data.excess.building.amount, data.excess.building.currency) }</strong></span>
    </div>
    <div class="flex flex-column margin-right-small" *ngIf="data.excess && data.excess.contents">
      <span class="margin-bottom-tiny text-small">Contents excess</span>
      <span><strong>${ formatCurrency(data.excess.contents.amount, data.excess.contents.currency) }</strong></span>
    </div>
    <div class="flex flex-column margin-right-small">
      <span class="margin-bottom-tiny text-small">Next monthly payment</span>
      <span><strong>${ formatCurrency(data.firstPayableInvoice.amount, data.firstPayableInvoice.currency) } (Inc GST)</strong></span>
    </div>
  `,
  mobileSnapshot: (data: any, suffix: string): string => `
    <div class="flex flex-column margin-right-small">
      <span class="margin-bottom-tiny text-small">Next monthly payment</span>
      <span><strong>${ formatCurrency(data.firstPayableInvoice.amount, data.firstPayableInvoice.currency) } ${ suffix }</strong></span>
    </div>
  `,
}

export const BADGE_STATUS = {
  active: 'success',
  upcoming:'default',
  cancelled: 'error',
  inactive: 'inactive'
}

export const EXTRAS_CONSTANTS: any = {
  active_setting: {
    settings: {
      type: 'decorative',
      layout: 'vertical',
      iconName: '',
      iconClass: 'decorative',
      action: {
        type: 'link',
        text: 'Details',
        icon: 'east',
        url: '',
        flow: 'info'
      }
    }
  },
  additional_setting: {
    settings: {
      type: 'tile',
      layout: 'vertical',
      iconName: '',
      action: {
        type: 'link',
        text: 'Add to my cover',
        icon: 'add',
        url: '',
        flow: 'endorsement'
      }
    }
  },
  extra_details: {
    R: {
      label: "Roadside assistance",
      info: "Essential roadside assistance to get you back on the road",
      icon: "options-roadsideassistance"
    },
    W: {
      label: "Excess-free windscreen",
      info: "We'll repair or replace your front windscreen once every 12 months and you won't have to pay an excess",
      icon: "options-excessfreewindscreen"
    },
    O: {
      label: "Sports Cover",
      info: "Up to $3,000 to cover your sports gear whilst it's in or on your car",
      icon: "options-sportcover"
    },
    K: {
      label: "Kanga Cover",
      info: "We'll waive your excess on your first collision with an animal every 12 months",
      icon: "options-kangacover"
    },
    H: {
      label: "Hire car 10 days",
      info: "If your car is being fixed during a claim, we'll organise a hire car for up to 10 days",
      icon: "options-hirecar"
    },
    HA: {
      label: "Home assistance",
      info: "24/7 rapid response assistance from plumbers, electricians and locksmiths for common emergencies",
      icon: "management-homeinsurance"
    },
    cruise: {
      label: "",
      info: "",
      icon: "travel-cruise",
    },
    gadget: {
      label: "",
      info: "",
      icon: "valuables-electronics"
    },
    snow: {
      label: "",
      info: "",
      icon: "travel-snow"
    },
    esim: {
      label: "",
      info: "",
      icon: "marketing-optionals"
    },
    class_pass: {
      label: "",
      info: "",
      icon: "marketing-flexibleaccess"
    },
    brand_award: {
      label: "",
      info: "",
      icon: "travel-avios"
    },
    flight_delay: {
      label: "",
      info: "",
      icon: "management-updateflightdetails"
    },
    brand_lottery: {
      label: "",
      info: "",
      icon: "travel-avios"
    },
    brand_protect: {
      label: "",
      info: "",
      icon: "travel-avios"
    },
    cancellation_flex: {
      label: "",
      info: "",
      icon: "travel-tripcancellation"
    }
  }
}

export const POLICY_DETAIL_CONFIG = {
  claimsActiveConfig: {
    layout: 'group',
    title: 'Active claims',
    status: 'default'
  },
  claimsCompletedConfig: {
    layout: 'group',
    title: 'Completed claims',
    status: 'success'
  },
  policyDocumentConfig: {
    title: 'Policy documents',
    layout: 'group'
  },
  policyContactConfig: {
    title: 'Authorised contacts',
    layout: 'group',
    footnote: `<a href="" class="intercom-launcher">Chat with one of our friendly agents</a> to add, edit, or remove an authorised contact.`
  },
  extrasActiveConfig: {
    label: 'Active extras',
    className: 'active-extra'
  },
  policyMobileExcessConfig: {
    title: 'Your excess',
    layout: 'list',
    footnote: `Your excess will be higher until you have successfully validated your phone using our Condition Check. Visit <a href="https://www.huddleinsurance.com/uk/faqs" target="_blank">huddleinsurance.com/uk/faqs</a> to find out how to validate your phone.`
  }
}

export const POLICY_EXCESS = {
  mobile: {
    damage: {
      key: 'excess_damage',
      name: 'Accidental Damage'
    },
    breakdown: {
      key: 'excess_breakdown',
      name: 'Breakdown'
    },
    theft: {
      key: 'excess_theft',
      name: 'Theft'
    },
    loss: {
      key: 'excess_loss',
      name: 'Loss'
    }
  }
}
